import { Backdrop, CircularProgress } from '@mui/material'
import { createContext, FC, ReactNode, useContext, useState } from 'react'

interface LoaderContextProps {
  loader: (state: boolean) => void
}

const LoaderContext = createContext<LoaderContextProps | undefined>(undefined)

export const LoaderProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)

  const loader = (state: boolean) => setIsLoading(state)

  return (
    <LoaderContext.Provider value={{ loader }}>
      {children}
      {/* <Loader isLoading={isLoading} /> */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </LoaderContext.Provider>
  )
}

export const useLoader = (): LoaderContextProps => {
  const context = useContext(LoaderContext)
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider')
  }
  return context
}
